import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@/scss/vuetify/overrides.scss";
Vue.use(Vuetify);

// Partify theme — Polaris-style neutrals with Xero-style status colours.
// primary is the dark Polaris action colour; links/info use blue.
const theme = {
  primary: "#303030",
  secondary: "#616161",
  info: "#005BD3",
  success: "#29845A",
  warning: "#B28400",
  error: "#C70A24",
  accent: "#005BD3",
  default: "#303030",
};

export default new Vuetify({
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
    dark: false, // If you want to set dark theme then dark:true else set to false
  },
  rtl: false, // If you want to set rtl theme then rtl:true else set to false
});
